export enum BlogQueryParams {
  PageSize = "pageSize",
  ActivePage = "page",
  SortBy = "sortBy",
  FromDate = "fromDate",
  ToDate = "toDate",
  SearchTerm = "searchTerm",
}
